import dayjs from 'dayjs';
import Parse from 'parse';

const parseCode = new Parse.Object('ProductMst');

export const saveProduct = (data, isUpdate = false, id) => {
  const { name, devices, alarms } = data
  console.log("Product data", data)

  let newProduct = new Parse.Object('ProductMst');
  newProduct.set('name', name);
  newProduct.add("deviceId", devices);
  newProduct.add("codeId", alarms);

  // Code to save relation ***
  // let deviceRelation = newProduct.relation('deviceId')
  // deviceRelation.add(devices);
  // let alarmRelation = newProduct.relation('AlarmId')
  // alarmRelation.add(alarms);
  //*******/

  return newProduct.save()
}

export const editProduct = ({ updateobj, data }) => {
  console.log("data , data", updateobj, data);

  const { name, desc } = data
  updateobj.set('name', name);
  updateobj.set('desc', desc);
  return updateobj.save()
}

export const deleteProduct = (deleteObj) => {

  return deleteObj.destroy()

}

export const getProduct = async (filters = {}, fields = 'name,desc') => {
  let queryFilters = filters
  const { rows, page, first, searchText, sortField, sortOrder } = queryFilters

  const queries = [];

  if (searchText) {
    queries.push(new Parse.Query(parseCode).matches('name', searchText, "i"));
  }


  const mainQuery = searchText ? new Parse.Query.or(...queries) : new Parse.Query("ProductMst");
  mainQuery.skip(first)
  mainQuery.limit(rows)
  switch (sortOrder) {
    case -1:
      mainQuery.descending(sortField);
      break;
    case 1:
      mainQuery.ascending(sortField);
      break;
    default:
      mainQuery.descending("createdAt");
      break;
  }

  mainQuery.withCount();
  mainQuery.include('deviceId');
  mainQuery.include('codeId');

  return mainQuery.find()
}

